import { Component } from '@mycolorway/tao';
import 'next/stylesheets/components/lazy-load.scss';
import { matches } from 'next/javascripts/modules/dom';
import { setOuterHTML } from 'next/javascripts/modules/utils';

Component('tr-lazy-load', {
  ready() {
    const placeholders = [...this.children]
      .filter(child => matches(child, '.placeholder'));

    if (!window.IntersectionObserver) {
      setTimeout(() => {
        placeholders.forEach((placeholder) => {
          // eslint-disable-next-line no-param-reassign
          placeholder.outerHTML = placeholder.dataset.item;
        });
      });
      return;
    }

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '700px 0px 700px 0px',
    });
    placeholders.forEach((placeholder) => {
      this.observer.observe(placeholder);
    });
  },

  handleIntersection(entries) {
    entries.forEach((entry) => {
      // entry.isIntersecting is undefined in chrome under v57
      if (entry.isIntersecting === undefined || entry.isIntersecting === true) {
        setOuterHTML(entry.target, entry.target.dataset.item);
        this.observer.unobserve(entry.target);
      }
    });
  },

  disconnected() {
    if (this.observer) this.observer.disconnect();
  },
});
